import Vue from 'vue'
import Vuex from 'vuex'
import createPersistedState from 'vuex-persistedstate'

import Avatars from '@/store/modules/avatars'
import ui from '@/store/modules/ui'
import newUser from '@/store/modules/new-user-register'
import auth from '@/store/modules/auth'
import modal from '@/store/modules/modal'
import print from '@/store/modules/print'
import filter from '@/store/modules/filter'
import paciente from '@/store/modules/paciente'
import agendamentos from '@/store/modules/agendamentos'
import atestados from '@/store/modules/atestados'
import receitas from '@/store/modules/receitas.js'
import exames from '@/store/modules/exames.js'
import relatoriosMedicos from '@/store/modules/relatorios-medicos.js'
import cirurgia from '@/store/modules/cirurgia.js'
import solicitacaoReceita from '@/store/modules/solicitacao-receita.js'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    isLoading: undefined
  },

  getters: {
    isLoading: (state) => {
      return state.isLoading
    }
  },

  mutations: {
    setLoadingState (state, loading) {
      state.isLoading = loading
    }
  },

  actions: {
    changeLoadingState ({ commit }, loading) {
      commit('setLoadingState', loading)
    }
  },

  modules: {
    paciente,
    Avatars,
    ui,
    newUser,
    auth,
    modal,
    agendamentos,
    print,
    filter,
    atestados,
    receitas,
    exames,
    relatoriosMedicos,
    cirurgia,
    solicitacaoReceita
  },

  plugins: [
    createPersistedState({
      paths: [
        'userInfo',
        'proximosAgendamentos',
        'lastDocuments',
        'dadosPaciente',
        'atestados',
        'relatorios',
        'medicalReport',
        'exames',
        'exameDocumento',
        'examsFilter',
        'agendamentoDocumento',
        'relatoriosMedicos',
        'cirurgia',
        'solicitacaoReceita'
      ]
    })
  ]
})
